import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import CircularProgress from '@material-ui/core/CircularProgress';

// services
import { MaskCNPJ, MaskCel } from "beaktShared/helpers/masks";
import { UsePostApi, UsePutApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function FranquiaForm({ item, handleView }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors } = useForm({ mode: "onChange" });
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [loading, setLoading] = React.useState(false);

    const endPointLayoutAnamnese = "LayoutAnamnese/";
    const [habilitaProntuarioCheckbox ,setHabilitaProntuarioCheckbox] = React.useState(false);
    const [habilitaUtilizaCSJPIXCheckbox, setHabilitaUtilizaCSJPIXCheckbox] = React.useState(false);
    
    const [layoutAnamneseOptions, setLayoutAnamneseOptions] = React.useState([
        { text: "Nenhum", value: null },
    ]);
    const [loadingLayoutAnamnese, setLoadingLayoutAnamnese] = React.useState(false);
    const [layoutAnamnese, setLayoutAnamnese] = React.useState("");

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    const [contratoVendaOptions, set_contratoVendaOptions] = React.useState([
        { text: "Nenhum", value: "" },
        { text: "Emagrecentro", value: "Emagrecentro" },
        { text: "CamaCam", value: "CamaCam" },
        { text: "DM2", value: "DM2" }
    ]);
    const [contratoVendaSelected, set_contratoVendaSelected] = React.useState("");
    const hanndleContratoVendaChange = (event) => {
        let value = event
        set_contratoVendaSelected(value);
        setValue("contratoVenda", value);
    }

    const [avaliacaoOptions, set_avaliacaoOptions] = React.useState([
        { text: "Nenhum", value: "" },
        { text: "Emagrecentro", value: "Emagrecentro" },
        { text: "Dr. Diabetes", value: "Dr. Diabetes" }
    ]);
    const [avaliacaoSelected, set_avaliacaoSelected] = React.useState("");
    const handleAvaliacaoChange = (event) => {
        let value = event
        set_avaliacaoSelected(value);
        setValue("avaliacao", value);
    }

    const [nomearquivo1, setnomearquivo1] = React.useState(null);
    const [arquivo1, setarquivo1] = React.useState(null);
    const [nomearquivo2, setnomearquivo2] = React.useState(null);
    const [arquivo2, setarquivo2] = React.useState(null);
    const handleArquivo1Change = event => {
        const arquivo = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.onload = function (oFREvent) {
            setarquivo1(oFREvent.target.result.replace("data:image/png;base64,", ""));
        }
        fileReader.readAsDataURL(arquivo)
    }

    const handleArquivo2Change = event => {
        const arquivo = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.onload = function (oFREvent) {
            setarquivo2(oFREvent.target.result.replace("data:image/png;base64,", ""));
        }
        fileReader.readAsDataURL(arquivo)
    }

    useEffect(() => {
        loadDadosItem();
    }, [item]);

    const loadDadosItem = () => {
        if (item != null) {
            setValue('descricao', item.descricao);
            setValue('razaoSocial', item.razaoSocial);
            setValue('email', item.email);
            setValue('nomeResponsavel', item.nomeResponsavel);
            setValue('telefone', item.telefone);
            setValue('cnpjcpf', item.cnpjcpf);
            setAtivoCheckbox(item.ativo);
            setHabilitaProntuarioCheckbox(item.habilitaProntuario);
            loadLayoutAnamnese();
            setLayoutAnamnese(item.layoutAnamneseId);
            setHabilitaUtilizaCSJPIXCheckbox(item.utilizaCSJPix);

            if (item.logoPequeno != null && item.logoPequeno != "")
                setnomearquivo1(item.logoPequeno);
            if (item.logoGrande != null && item.logoGrande != "")
                setnomearquivo2(item.logoGrande);

            set_contratoVendaSelected(item.contratoVenda == null ? "" : item.contratoVenda);
            set_avaliacaoSelected(item.avaliacao == null ? "" : item.avaliacao);
        }
    }

    const loadLayoutAnamnese = () => {
        setLoadingLayoutAnamnese(true);
        UseGetApiSimple(endPointLayoutAnamnese, 0).then(result => {
            if(result.status !== 200)
            {
                showNotification(result.message,'danger');
                setLoadingLayoutAnamnese(false);
                return false; 
            }
            else
            {
                const arrayLayoutAnamnese = [
                    { text: "Nenhum", value: null },
                    ...(result.data ?? []).map(({ layoutAnamneseId, descricao }) => ({ text: descricao, value: layoutAnamneseId }))
                ];
                setLayoutAnamneseOptions(arrayLayoutAnamnese);
                setLoadingLayoutAnamnese(false);
            }
        });
    }

    const onSubmit = data => {
        let json_submit = {
            franquiaId: item != null ? item.franquiaId : 0,
            descricao: data.descricao,
            CNPJCPF: data.cnpjcpf,
            razaoSocial: data.razaoSocial,
            ativo: ativoCheckbox,
            telefone: data.telefone,
            email: data.email,
            nomeResponsavel: data.nomeResponsavel,
            logoPequeno: arquivo1 == null ? nomearquivo1 : Math.random().toString(36).substr(2, 9),
            logoPequenoBase64: arquivo1,
            logoGrande: arquivo2 == null ? nomearquivo2 : Math.random().toString(36).substr(2, 9),
            logoGrandeBase64: arquivo2,
            contratoVenda: contratoVendaSelected,
            avaliacao: avaliacaoSelected,
            habilitaProntuario: habilitaProntuarioCheckbox,
            layoutAnamneseId: layoutAnamnese,
            utilizaCSJPIX: habilitaUtilizaCSJPIXCheckbox,
        }

        setLoading(true);
        if (item != null) {
            UsePutApi("franquias", "", json_submit).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setLoading(false);
                    return false;
                }
                showNotification(result.message, 'success');
                setTimeout(() => {
                    handleView(true, result.data);
                    setLoading(false);
                    return true;
                  }, 2000);
            });
        }
        else {
            showNotification('Só é possível editar uma Franquia.','danger');
        }
    };

    const handleViewForm = () => {
        handleView();
    };

    const handleLayoutAnamneseChange = (event) => {
        let value = event
        setLayoutAnamnese(value);
        setValue("layoutAnamnese", value);
    }

    return (
        <div className="maxContent">
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />
            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    Cadastro de Franqueadores - <small>{t('information_message.fill_in_your_details')}</small>
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.cnpjcpf ? true : false}
                                                label={t('label.cpf') + " / " + t('label.cnpj') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="cnpjcpf"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskCNPJ,
                                                    maxLength: 20,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.cnpjcpf && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={8}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.descricao ? true : false}
                                                label={"Descrição"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="descricao"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.descricao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={8}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.razaoSocial ? true : false}
                                                label={"Razão Social"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="razaoSocial"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.razaoSocial && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.telefone ? true : false}
                                                label={"Telefone"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="telefone"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskCel,
                                                    maxLength: 20,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.telefone && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.email ? true : false}
                                                label={"Email"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="email"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.email && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.nomeResponsavel ? true : false}
                                                label={"Nome Responsável"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="nomeResponsavel"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 100,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.nomeResponsavel && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={"select__label"}>Contrato Venda</label>
                                            <Select
                                                styles={ValidSelect(false)}
                                                classNamePrefix="select"
                                                name="contratoVenda"
                                                placeholder="Selecione"
                                                value={contratoVendaOptions.filter(({ value }) => value == contratoVendaSelected)}
                                                getOptionLabel={({ text }) => text}
                                                getOptionValue={({ value }) => value}
                                                options={contratoVendaOptions}
                                                onChange={(value) => hanndleContratoVendaChange(value.value)}
                                                ref={() => register({ name: "contratoVenda" })
                                                }
                                            />
                                            {errors.contratoVenda &&
                                                <FormHelperText>
                                                    <span className="obg">{t('label.required')}</span>
                                                </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={"select__label"}>Avaliação</label>
                                            <Select
                                                styles={ValidSelect(false)}
                                                classNamePrefix="select"
                                                name="avaliacao"
                                                placeholder="Selecione"
                                                value={avaliacaoOptions.filter(({ value }) => value == avaliacaoSelected)}
                                                getOptionLabel={({ text }) => text}
                                                getOptionValue={({ value }) => value}
                                                options={avaliacaoOptions}
                                                onChange={(value) => handleAvaliacaoChange(value.value)}
                                                ref={() => register({ name: "avaliacao" })
                                                }
                                            />
                                            {errors.avaliacao &&
                                                <FormHelperText>
                                                    <span className="obg">{t('label.required')}</span>
                                                </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.arquivo1 ? true : false}
                                                type="file"
                                                label={"Logotipo Menu"}
                                                variant="outlined"
                                                accept=".png"
                                                onChange={handleArquivo1Change}
                                                inputRef={register({ required: false })}
                                                name="arquivo1"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <a href={process.env.REACT_APP_API_ENDPOINT + "anexos/" + nomearquivo1} target="_blank">{nomearquivo1 === null ? "" : 'Visualizar Arquivo'}</a>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.arquivo2 ? true : false}
                                                type="file"
                                                accept=".png"
                                                label={"Logotipo Home"}
                                                variant="outlined"
                                                onChange={handleArquivo2Change}
                                                inputRef={register({ required: false })}
                                                name="arquivo2"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <a href={process.env.REACT_APP_API_ENDPOINT + "anexos/" + nomearquivo2} target="_blank">{nomearquivo2 === null ? "" : 'Visualizar Arquivo'}</a>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={"select__label"}>Layout Anamnese</label>
                                            <Select
                                                styles={ValidSelect(false)}
                                                classNamePrefix="select"
                                                name="layoutAnamnese"
                                                placeholder="Selecione"
                                                isLoading={loadingLayoutAnamnese}
                                                value={layoutAnamneseOptions.filter(({ value }) => value == layoutAnamnese)}
                                                getOptionLabel={({ text }) => text}
                                                getOptionValue={({ value }) => value}
                                                options={layoutAnamneseOptions}
                                                onChange={(value) => handleLayoutAnamneseChange(value.value)}
                                                ref={() => register({ name: "layoutAnamnese" })
                                                }
                                            />
                                            {errors.contratoVenda &&
                                                <FormHelperText>
                                                    <span className="obg">{t('label.required')}</span>
                                                </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={habilitaProntuarioCheckbox}
                                                    onClick={event => { setHabilitaProntuarioCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="habilitaProntuario"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.enable_medical_records')}></FormControlLabel>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={habilitaUtilizaCSJPIXCheckbox}
                                                    onClick={event => { setHabilitaUtilizaCSJPIXCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="habilitaUtilizaCSJPix"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.enable_pix_csj')}>
                                        </FormControlLabel>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.system_active')}></FormControlLabel>
                                    </GridItem>
                                </GridContainer>
                                
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>{t('label.loading') + "..."}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}